export default __webpack_public_path__ + "static/media/Linkedin.ea10e3f0.svg";